import FormFieldGroup from './FormFieldGroup'
import PropTypes, { oneOf } from 'prop-types'
import { useCallback, useEffect, useState } from 'react'

function FormFieldNumber(props){
    let [hasError, setErrorState] = useState(false)
    let [errorCause, setErrorCause] = useState("")
    let [isFocused, setIsFocused] = useState(false)
    let [firstFocus, setfirstFocus] = useState(false) //Only run validation on fields that have already been visited

    useEffect(()=>{
        if(props.forceErrorCheck === true){
            setfirstFocus(true)
            checkErrors({target: {value: props.value}, preventDefault: ()=>{/*do nothing*/}})
        }
        if(firstFocus && !isFocused){
            checkErrors({target: {value: props.value}, preventDefault: ()=>{/*do nothing*/}})
        }
    },[props.noLessthan,props.noMoreThan,props.forceErrorCheck]) // Callback is the changes we're looking for

    const setFocus = useCallback((isfocused,e) => {
        setfirstFocus(true)
        setIsFocused(isfocused)
        if(!isfocused){
            checkErrors(e)
        }
    })

    const checkErrors = useCallback((e)=>{ //Use callback is the same as function.bind(this) need to bind it to the specific component
        let val = (props.value && props.value) !== 0 ? props.value : cleanNumber(e.target.value, e)
        if(props.noLessthan){
            let nlt = props.noLessthan.number || props.noLessthan
            //HANDLE ERRORS AND RETURN IF VAL LESS THAN =  TRUE
            if(val < nlt){
                setErrorState(true)
                setErrorCause("nlt")
                if(props.noLessthan && props.noLessthan.type !== "warning"){
                    props.onFieldError && props.onFieldError(props.name)
                }   
                return
            }
        }
        if(props.noMoreThan){
            let nmt = props.noMoreThan.number || props.noMoreThan
            //HANDLE ERRORS AND RETURN IF VAL MORE THAN =  TRUE
            if(val > nmt){
                setErrorState(true)
                setErrorCause("nmt")
                if(props.noMoreThan && props.noMoreThan.type !== "warning"){
                    props.onFieldError && props.onFieldError(props.name)
                } 
                return
            }
        }
        if(hasError){setErrorState(false)}
        props.onFieldErrorCleared && props.onFieldErrorCleared(props.name)
    })

    return(
        <FormFieldGroup title={props.title}
            errorElement={hasError && (<span
                                        className={(props.noLessthan && props.noLessthan.type) || (props.noMoreThan && props.noMoreThan.type) || "error"}>
                                        {(errorCause === "nlt" ? (props.noLessthan.message ? props.noLessthan.message : `${titleText(props)} cannot be less than ${props.noLessthan.number || props.noLessthan}`) : (props.noMoreThan.message ? props.noMoreThan.message : `${titleText(props)} cannot be more than ${props.noMoreThan.number || props.noMoreThan}`))}
                                        </span>)}
            className={((hasError ? "has-error" : "") + (isFocused ? " focused" : "") + (hasError && isWarning(props,errorCause) ? " warning" : ""))}
            >
            <span className="symbol">
                {props.symbol}
            </span>
            <input
            autoComplete="off"
            type="text"
            name={props.name}
            value={props.value ? commaFormatted(props.value) : (firstFocus ? '' : '')} //Do not let this default to 0 when the thing is empty
            onChange={(e)=> props.onChange(props.name,cleanNumber(e.target.value, e))}
            pattern="\d*"
            inputMode="numeric"
            onBlur={(e)=>setFocus(false,e)}
            onFocus={()=>setFocus(true)}
            
            />
        </FormFieldGroup>
    )
}

function isWarning(props, errorCause){
    if(errorCause === "nlt" && props.noLessthan.type && props.noLessthan.type === "warning"){
        return true
    }
    if(errorCause === "nmt" && props.noMoreThan.type && props.noMoreThan.type === "warning"){
        return true
    }
    return false
}

export function titleText(props){
    if(typeof props.title === "string"){
        return props.title
    }
    if(props.title instanceof Object && props.titleText){
       return props.titleText
    }
    return props.name
}

FormFieldNumber.propTypes = {
    symbol: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string,PropTypes.node]).isRequired,
    value: PropTypes.number.isRequired,
    noLessthan: PropTypes.oneOfType([PropTypes.number, PropTypes.exact({
        number: PropTypes.number,
        type: oneOf(["error","warning"]),
        message: PropTypes.string
    })]),
    noMoreThan: PropTypes.oneOfType([PropTypes.number, PropTypes.exact({
        number: PropTypes.number,
        type: oneOf(["error","warning"]),
        message: PropTypes.string
    })]),
    onFieldError: PropTypes.func,
    onFieldErrorCleared: PropTypes.func,
    titleText: function(props){
        if(props['title'] && typeof (props['title']) !== "string" && !props['titleText']){
            return new Error(`You must provide a titleText prop if you are passing a node as a title: ${props.name}`)
        }
    },
    forceErrorCheck: PropTypes.bool //This value is irrelevant, it triggers the checkerror function whenever the value changes
}


function cleanNumber(number, e){

    e.preventDefault()
    if(!/\d/.test(e.target.value)){
        e.preventDefault()
        return false;
    }
    else{
        if(number.toString().length > 11){
            number = number.toString().substring(0,11)
        }
        parseFloat(number)
        return parseFloat(number.toString().replaceAll(",","")) || Number(number) || 0
    }
}

export function commaFormatted(amount) {
    let ab = amount.toString().replace("/[a-zA-Z,+-{}*&\^%$#@!]/g", "");
    return ab.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function roundToDollar(number) {
    return Math.round(number);
}

export default FormFieldNumber;